import { PlainButton } from '@findy-code/yuffie/ui/button';
import { useState } from 'react';

import { MemberItem } from './member-item.component';
import styles from './style.module.scss';

type Props = {
  members: {
    id: number;
    name: string;
    githubAccount?: string | null | undefined;
  }[];
};

const MAX_MEMBER_LENGTH = 3;

export const Members = ({ members }: Props) => {
  const [showAll, setShowAll] = useState(false);
  const showMembers = showAll ? members : members.slice(0, MAX_MEMBER_LENGTH);

  return (
    <div>
      <ul className={styles.memberList}>
        {showMembers.map((member, index) => (
          <li key={index}>
            <MemberItem
              githubAccount={member.githubAccount}
              name={member.name}
            />
          </li>
        ))}
      </ul>
      {members.length > MAX_MEMBER_LENGTH && (
        <div className={styles.toggleButtonWrapper}>
          <PlainButton onClick={() => setShowAll((current) => !current)}>
            {showAll ? '▲一部を表示する' : '▼全員を表示する'}
          </PlainButton>
        </div>
      )}
    </div>
  );
};
